import React from 'react';
import { FormGroup, SelectBoxSkeleton } from '@sbt-web/ui';

import styles from './FiltersSkeletons.module.scss';

type Props = {
  size: 'small' | 'large';
};

const LOADING_SKELETONS = Array.from({ length: 5 }, (_, index) => index);

const FiltersSkeletons = ({ size }: Props) => {
  return (
    <div>
      {LOADING_SKELETONS.map((id) => (
        <SimpleFilterSkeleton key={id} size={size} />
      ))}
    </div>
  );
};

const SimpleFilterSkeleton = ({ size }: Props) => (
  <FormGroup>
    <span className={styles.skeleton}></span>
    <SelectBoxSkeleton flavor={size} />
  </FormGroup>
);

export default FiltersSkeletons;
